import { getServerRequest, patchServerRequest } from '@/helpers/serverRequest.helper';
import { store } from '@/store/store';
const httpURL = store.getters.httpURL;

export const getLogsOficio = async(tipo, idOficio) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/logs/oficio/${tipo}/${idOficio}`;
    return await getServerRequest(url, config);
}

export const getLogsOficios = async(tipo) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/logs/oficio/${tipo}`;
    return await getServerRequest(url, config);
}